export default "__VITE_ASSET__6jJsJFqALfPLhO5QJBlJcw__ 480w, __VITE_ASSET__$Uz2JHrPn9gid3VmLp8wGA__ 768w, __VITE_ASSET__cP1PlwIRSln8iiklOw2aSQ__ 1122w";